// 入力モード
export type InputType = 'read' | 'write' | 'reWrite' | undefined;

// 入力モード設定値
export const CI_INPUT_MODE = {
    READ: 'read' as InputType,
    WRITE: 'write' as InputType,
    RE_WRITE: 'reWrite' as InputType,
};

// 個人情報入力画面内容
export type CustomerInformationInputType = {
    company: string; // 会社名
    division: string; // 部署名
    name: string; // お名前
    kana: string; // ふりがな
    mail: string; // メールアドレス
    mailReInput: string; // メールアドレス(再)
    phone?: string; // 電話番号
    reasonId?: string; // お問い合わせ理由ID
    reasonComment?: string; // お問い合わせ理由コメント
    pPolicyCheck: boolean; // 個人情報保護方針チェック
};

// 個人情報入力画面内容 初期値
export const CI_INPUT_TYPE_INIT: CustomerInformationInputType = {
    company: '',
    division: '',
    name: '',
    kana: '',
    mail: '',
    mailReInput: '',
    phone: '',
    reasonId: '',
    reasonComment: '',
    pPolicyCheck: false,
};

// 項目名
export const CI_INPUT = {
    COMPANY: '会社名',
    DIVISION: '部署名',
    NAME: 'お名前',
    KANA: 'ふりがな',
    MAIL: 'メールアドレス',
    MAIL_RE: 'メールアドレス確認',
    PHONE: '電話番号',
    REASON_DETAIL: '「当社を知ったきっかけ」詳細',
    POLICY_CHACK: '個人情報保護方針同意チェック',
};

// 入力欄最大長
export const TEXT_MAX_LENGTH = 512;

export const TEL_TEXT_MAX_LENGTH = 36;

// 備考入力欄最大長
export const DETAIL_MAX_LENGTH = 512;

// メールアドレス欄最大長
export const MAIL_ADDRESS_MAX_LENGTH = 254;
